module.exports = __webpack_public_path__ + "static/home-page-15fe5112f356318c42143ab36e8d6ca5.png";